import {fabric} from 'fabric';
import {fabricGif} from '~/common/canvas/animation/gif/Gif';

fabric.Gif = fabric.util.createClass(fabric.Image, {
  type: 'gif',
  originalUrl: '',
  initialize(options, extra) {
    // biome-ignore lint/suspicious/noAssignInExpressions: dont assign in expressions
    // biome-ignore lint/style/noParameterAssign: dont assign param
    options || (options = {});
    this.callSuper('initialize', options, extra);
  },

  toObject(propertiesToInclude) {
    // biome-ignore lint/correctness/noUnusedVariables: src is intentionally unused
    const {src, ...object} = this.callSuper(
      'toObject',
      ['originalUrl'].concat(propertiesToInclude)
    );
    return object;
  },
});

fabric.Gif.fromURL = (url, callback, imgOptions) => {
  fabric.util.loadImage(url, (img, isError) => {
    callback && callback(new fabric.Gif(img, imgOptions), isError);
  });
};

fabric.Gif.fromObject = (object, callback) =>
  fabricGif(object.originalUrl, {originalUrl: object.originalUrl}, object.frameWidth).then(
    (gif) => {
      gif.set({...object});
      callback(gif, false);
    }
  );
